import { useState, useCallback, useMemo, useEffect } from 'react';
import { downloadDocumentFromUrl } from '../../utils/helpers';
import { Modal, Button, Table, Form, InputGroup, Row, Col } from 'react-bootstrap';
import { getAsset, getAssetTitles, getAssetTitleUrl, uploadAssetTitle } from '../../utils/api';
import Loader from '../Loader';
import Header from '../Header';
import { faCar, faEllipsis, faTrashCan, faArrowsTurnToDots, faPencil, faPlus, faCirclePlus, faFile, faCloudDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatCurrency, formatDateToMMDDYYYYWithTime, openDocumentInNewTab } from '../../utils/helpers';
import ShowMenuButton from '../ShowMenuButton';
import CreateAssetTitleModal from './CreateAssetTitleModal'
import Error from '../Error';
import PdfPreviewModal from './PdfPreviewModal';

const ViewAssetModal = ({ show, onHide, asset }) => {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [data, setData] = useState([]);
    const [showUploadTitleModal, setShowUploadTitleModal] = useState(false);

    const [showPdfPreviewModal, setShowPdfPreviewModal] = useState(false);
    const [pdfPreviewData, setPdfPreviewData] = useState(null);

    useEffect(() => {
        fetchData();
    }, [show]);

    const fetchData = async () => {
        if (show) {
            setLoading(true);
            setError(null);
            const data = asset && await getAsset(asset.Id);
            if (data) {
                setData(data);
            }
            else {
                setError('Failed to fetch asset');
            }
            setLoading(false);
        }
        else {
            setData([]);
            setError(null);
            setLoading(false);
        }
    };
    const handleActionClick = async (name, d) => {
        if (name === 'Download') {
            // var obj = { title: d.TitleNumber };
            // obj.url = await getAssetTitleUrl(d.Id, true)
            // obj.downloadUrl = await getAssetTitleUrl(d.Id, false)

            // setPdfPreviewData(obj);
            // setShowPdfPreviewModal(true);

            var url =  await getAssetTitleUrl(d.Id, false);
            downloadDocumentFromUrl(url, d.TitleNumber + '.png')
            return;
        }
    }

    const uploadAssetTitleClicked = () => {
        setShowUploadTitleModal(true);
        return;
    }

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" style={{ zIndex: 1050 }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>View Asset (Id={asset?.Id})</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ padding: 10 }}>
                        {loading ? <Loader /> : error ? <Error /> : (
                            <>
                                <Header title={asset?.Vin} description="Details pertaining to the asset" />
                                <Row>
                                    <Table striped bordered hover responsive>
                                        <thead>
                                            <tr>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    ID
                                                </th>
                                                <th tyle={{ whiteSpace: 'nowrap', }}>
                                                    Class
                                                </th>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    Year
                                                </th>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    Make
                                                </th>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    Model
                                                </th>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    Color
                                                </th>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    VIN
                                                </th>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    Adj. Capital Cost
                                                </th>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    Credits
                                                </th>
                                                <th style={{ whiteSpace: 'nowrap', cursor: 'pointer', }}>
                                                    Credit Expiry
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {[data]?.map((d, idx) => (
                                                <tr key={idx}>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Id}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.AssetClass?.Name}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Year}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Make}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Model}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Color}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Vin}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{formatCurrency(d?.AdjustedCapitalCost)}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{formatCurrency(d?.Credit)}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{new Date(d?.CreditExpiryDate).toLocaleDateString()}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Row>
                                <br /><br />
                                <Row>
                                    <div>
                                        <div style={{ marginBottom: '8px', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', }}>
                                            Owners
                                        </div>

                                        <Table striped bordered hover responsive>
                                            <thead>
                                                <tr>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Id
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Name
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Start Date
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        End Date
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.AssetOwners
                                                    ?.slice() // optional: clone to avoid mutating original array
                                                    ?.sort((a, b) => {
                                                        if (a.EndDate === null && b.EndDate !== null) return -1; // null first
                                                        if (a.EndDate !== null && b.EndDate === null) return 1;
                                                        if (a.EndDate === null && b.EndDate === null) return 0;
                                                        return new Date(a.EndDate) - new Date(b.EndDate); // oldest last
                                                    })
                                                    ?.map((d, idx) => (
                                                        <tr key={idx}>
                                                            <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Id}</td>
                                                            <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.BusinessPartner?.Name}</td>
                                                            <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{formatDateToMMDDYYYYWithTime(d?.StartDate)}</td>
                                                            <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{formatDateToMMDDYYYYWithTime(d?.EndDate)}</td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Row>
                                <br /><br />
                                <Row>
                                    <div>
                                        <div style={{ marginBottom: '8px', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', }}>
                                            Odometer Readings
                                        </div>

                                        <Table striped bordered hover responsive>
                                            <thead>
                                                <tr>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Id
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Miles
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Reading Date
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.AssetOdometerReadings
                                                    ?.slice() // optional: clone to avoid mutating original array
                                                    ?.sort((a, b) => {
                                                        return new Date(a.ReadingDate) - new Date(b.ReadingDate); // oldest last
                                                    })
                                                    ?.map((d, idx) => (
                                                        <tr key={idx}>
                                                            <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Id}</td>
                                                            <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.ReadingValueMiles}</td>
                                                            <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{formatDateToMMDDYYYYWithTime(d?.ReadingDate)}</td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Row>
                                <br /><br />
                                <Row>
                                    <div>
                                        <div style={{ marginBottom: '8px', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', }}>
                                            Titles
                                            <FontAwesomeIcon icon={faCirclePlus} style={{ color: 'blue', fontSize: '20', cursor: 'pointer' }} onClick={uploadAssetTitleClicked} />
                                        </div>

                                        <Table striped bordered hover responsive>
                                            <thead>
                                                <tr>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Id
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        State
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Title Number
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Uploaded
                                                    </th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.AssetTitles?.map((d, idx) => (
                                                    <tr key={idx}>
                                                        <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Id}</td>
                                                        <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.TitlingState?.Code}</td>
                                                        <td style={{ whiteSpace: 'nowrap', width: '100%', verticalAlign: 'middle' }}>{d?.TitleNumber}</td>
                                                        <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{formatDateToMMDDYYYYWithTime(d?.UploadedDateTime)}</td>
                                                        <td style={{ whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}>{
                                                            <ShowMenuButton menuItems={[
                                                                { icon: <FontAwesomeIcon icon={faCloudDownload} />, name: 'Download', target: d, onClick: handleActionClick }
                                                            ]} />}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Row>
                            </>
                        )}
                    </div>
                </Modal.Body>

                <CreateAssetTitleModal
                    show={showUploadTitleModal}
                    onHide={(forceRefresh) => {
                        setShowUploadTitleModal(false)
                        if (forceRefresh)
                            fetchData();
                    }}
                    asset={asset}
                />

                <PdfPreviewModal
                    show={showPdfPreviewModal}
                    onHide={() => setShowPdfPreviewModal(false)}
                    data={pdfPreviewData} />

            </Modal >
        </>
    );
};

export default ViewAssetModal;